import React from "react";
import ErrorIcon from "../../elements/icon/error";

// --- 子元件：對話框內容 ---
// 職責：根據狀態顯示不同的提示、圖示和進度條
const DialogContent = React.memo(({ submitStatus, totalProgress, t }) => {
  const contentMap = {
    0: (
      <>
        <h1 className="text-[16px] py-2" role="alert">
          {t("submitSuccess")}
        </h1>
        <p className="text mt-3 font-ligh text-center" role="alert">
          {t("submitProcessing")}
        </p>
        <div className="bg-gray-600 h-[6px] mt-4 mx-6 rounded">
          <div
            role="progressbar"
            className="bg-rog-red h-full"
            style={{ width: `${totalProgress}%` }}
          />
        </div>
      </>
    ),
    1: (
      <h1 className="text-[16px] py-2 text-center" role="alert">
        {t("submitProcessDone")}
      </h1>
    ),
    2: (
      <>
        <h1 className="text-[16px] py-2" role="alert">
          {t("submitFailed")}
        </h1>
        <ErrorIcon className={"w-full justify-center flex my-4"} />
        <p className="text mt-3 font-light text-center" role="alert">
          {t("submitFailedContent")}
        </p>
      </>
    ),
    3: (
      <>
        <h1 className="text-[16px] py-2" role="alert">
          {t("file_upload_failed")}
        </h1>
        <ErrorIcon className={"w-full justify-center flex my-4"} />
        <p className="text mt-3 font-light text-center" role="alert">
          {t("file_upload_failed_content")}
        </p>
      </>
    ),
    4: <p className="text mt-5 px-5 font-light">{t("like_submit_message")}</p>,
  };

  return contentMap[submitStatus] || null;
});

export default DialogContent;
